import PropTypes from 'prop-types';
import { Dropdown, Menu, message, Modal } from 'antd';
import SubMenu from 'antd/lib/menu/SubMenu';
import React, { Component } from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { unsubscribeAllPodcasts, updateYourPodcastSettings } from '../../actions';
import { colors, fixedSpacing } from '../../lib/theme';
import { cleanFirebaseId, isEpisodeExplicitlyMarkedPlayed } from '../../lib/utils';
import memoizeOne from 'memoize-one';

class PodcastBadge extends Component {

    unplayedBadgeCount = memoizeOne((prevGuids, personalMarkPlayedValues, clearBadgesGuid) => {
        let unPlayedCount = 0;
        for (let guid of prevGuids) {
            if (guid == clearBadgesGuid) {
                break;
            }
            if (!personalMarkPlayedValues[(cleanFirebaseId(guid))]) {
                unPlayedCount++;
            }
        }
        return unPlayedCount;
    });

    render() {
        const { yourPodcastSettingsState, podcastExtraDetails, collectionId, personalMarkPlayedValues, clearBadgesMap } = this.props;
        const subscribedBadgeValue = yourPodcastSettingsState['subscribedBadgeOption'] || 0;
        if (subscribedBadgeValue == 0) {
            return <></>
        }
        const currentExtraDetails = podcastExtraDetails[collectionId];

        if (!currentExtraDetails) {
            return <></>
        }
        const prevGuids = currentExtraDetails['prevGuids'] || [];

        let isUnplayed = false;
        // console.dir(currentExtraDetails);
        if (currentExtraDetails['guid']) {
            // console.dir(currentExtraDetails);
            if (currentExtraDetails['guid'] !=
                clearBadgesMap[`${collectionId}`] &&
                !isEpisodeExplicitlyMarkedPlayed(
                    currentExtraDetails['guid'],
                    personalMarkPlayedValues)) {
                isUnplayed = true;
            }
        }

        if (subscribedBadgeValue == 2) {
            // console.dir(isUnplayed);
            if (isUnplayed) {
                return <div style={{ position: 'relative' }}>
                    <div style={{
                        position: 'absolute', backgroundColor: 'red', width: '16px', height: '16px', zIndex: '10', borderRadius: '50%',
                        right: '-4px', top: '-4px'
                    }}>&nbsp;</div>
                </div>
            } else {
                return <></>
            }
        }

        if (subscribedBadgeValue == 1) {
            let childText = '';
            const unPlayedCount = this.unplayedBadgeCount(
                prevGuids,
                personalMarkPlayedValues,
                clearBadgesMap[`${collectionId}`]);

            if (prevGuids.isEmpty &&
                currentExtraDetails['guid'] !=
                clearBadgesMap[`${collectionId}`]) {
                childText = '!';
            } else if (unPlayedCount > 0) {
                childText = unPlayedCount < 25 ? `${unPlayedCount}` : '25+';
            } else {
                return <></>
            }

            return (
                <div style={{ position: 'relative' }}>
                    <div style={{
                        position: 'absolute', backgroundColor: 'red', width: '16px', height: '16px', zIndex: '10', borderRadius: '30%',
                        right: '-4px', top: '-4px', color: 'white', fontSize: '8px', textAlign: 'center', paddingTop: '2px'
                    }}>{childText}</div>
                </div>
            )
        }

        return <></>

    }
}

PodcastBadge.propTypes = {
    yourPodcastSettingsState: PropTypes.object,
    podcastExtraDetails: PropTypes.object,
    clearBadgesMap: PropTypes.object,
    personalMarkPlayedValues: PropTypes.object,
    collectionId: PropTypes.string.isRequired,
    userDetails: PropTypes.object,
    updateYourPodcastSettings: PropTypes.func,
    unsubscribeAllPodcasts: PropTypes.func,
}

const mapStateToProps = (state) => {
    return {
        yourPodcastSettingsState: state.yourPodcastSettingsState,
        personalMarkPlayedValues: state.personalMarkPlayedValues,
        clearBadgesMap: state.clearBadgesMap,
        podcastExtraDetails: state.podcastExtraDetails,
        userDetails: state.userDetails,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateYourPodcastSettings: bindActionCreators(updateYourPodcastSettings, dispatch),
        unsubscribeAllPodcasts: bindActionCreators(unsubscribeAllPodcasts, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PodcastBadge)